import { useState, useMemo } from 'react'
import type { Issue, ListBoxOption } from '../types'

const getStatusCategoryKey = (issue: Issue): string | undefined => {
  if (!issue.status) return undefined
  if (typeof issue.status === 'object') {
    return (issue.status as { statusCategoryKey?: string }).statusCategoryKey
  }
  return issue.statusCategoryKey
}

export function useFilters(allIssues: Issue[]) {
  const [selectedType, setSelectedType] = useState<ListBoxOption>({ id: 0, name: 'All Issue Types' })
  const [selectedEpic, setSelectedEpic] = useState<ListBoxOption>({ id: 0, name: 'All Epics' })
  const [selectedStatus, setSelectedStatus] = useState<ListBoxOption>({
    id: 0,
    name: 'All Issue Statuses'
  })
  const [showStartingOnly, setShowStartingOnly] = useState<boolean>(false)

  const appliedIssues = useMemo(() => {
    let filtered = structuredClone(allIssues)

    if (selectedType && selectedType.id !== 0) {
      filtered = filtered.filter(issue => issue.type === selectedType.name)
    }

    if (selectedEpic && selectedEpic.id !== 0) {
      if (typeof selectedEpic.id === 'number' && selectedEpic.id < 0) {
        filtered = filtered.filter(issue => issue.epic == null)
      } else {
        filtered = filtered.filter(issue =>
          issue.epic ? (Number(issue.epic.id) === Number(selectedEpic.id)) : false
        )
      }
    }

    if (selectedStatus && selectedStatus.id !== 0) {
      if (selectedStatus.id === 1) {
        filtered = filtered.filter(issue => getStatusCategoryKey(issue) === 'done')
      } else if (selectedStatus.id === 2) {
        filtered = filtered.filter(issue => getStatusCategoryKey(issue) !== 'done')
      }
    }

    if (showStartingOnly) {
      filtered = filtered.filter(issue => issue.startedWith === true)
    }

    return filtered
  }, [allIssues, selectedType, selectedEpic, selectedStatus, showStartingOnly])

  return {
    filters: { selectedType, selectedEpic, selectedStatus, showStartingOnly },
    setFilters: { setSelectedType, setSelectedEpic, setSelectedStatus, setShowStartingOnly },
    appliedIssues
  }
}